<div class="inventory-container">
  <div class="inventory-header">
    <h2 class="inventory-header__heading">{{ 'inventory.header' | translate }}</h2>
    @if (!isEmpty()) {
      <ul class="inventory-header__tabs">
        <li [class.active-tab]="activeTab() === 'itemsList'">
          <a
            routerLink="items-list"
            (click)="setActiveTab('itemsList')"
            [class.active-tab]="activeTab() === 'itemsList'"
          >
            {{ 'inventory.itemsList' | translate }}
          </a>
        </li>
        <li [class.active-tab]="activeTab() === 'uploadItems'">
          <a
            routerLink="upload-items-list"
            (click)="setActiveTab('uploadItems')"
            [class.active-tab]="activeTab() === 'uploadItems'"
          >
            {{ 'inventory.uploadItemsList' | translate }}
          </a>
        </li>
      </ul>
    }
  </div>
  @if (isEmpty() && activeTab() === 'itemsList') {
    <div class="no-items-message">
      <h3 class="no-items-message__title">
        {{ 'inventory.messages.emptyInventory.title' | translate }}
      </h3>
      <p class="no-items-message__description">
        {{ 'inventory.messages.emptyInventory.description' | translate }}
      </p>
      <div class="no-items-message__buttons">
        <button class="no-items-message__button btn-white" (click)="openUploadItemsModal()">
          {{ 'inventory.messages.emptyInventory.uploadItems' | translate }}
        </button>
        <button class="no-items-message__button btn-primary" (click)="openAddProductModal()">
          {{ 'inventory.messages.emptyInventory.addProduct' | translate }}
        </button>
      </div>
    </div>
  } @else {
    <router-outlet />
  }
</div>
